import "./base/gsap";

import { runDefault, runComponentDefault, runModuleDefault, runLayoutDefault } from "./utils/runner-functions";

import { initVariables } from "./utils/variables";
import { initMouse } from "./utils/mouse";
import { initScroller, requestScrollTriggerRefresh } from "./base/scroll";
import { runLoader } from "./base/loader";

async function init() {
    initGlobalScripts();
    initLayoutScripts();
    initComponentScripts();
    initModuleScripts();

    await runLoader();
    // Animations after loader

    requestAnimationFrame(() => requestScrollTriggerRefresh(250));
}

function initGlobalScripts() {
    initVariables();
    initMouse();
    initScroller();
    runDefault("grid");
    runDefault("link-prefetch");
}

function initLayoutScripts() {
    runLayoutDefault("nav");
    runLayoutDefault("mobile-nav");
    runLayoutDefault("footer");
    runLayoutDefault("bg-wrap");
}

function initComponentScripts() {
    runComponentDefault("title-reveal", ".display, h1, .h1, h2, .h2, h3, .h3");
    runComponentDefault("card-reveal", ".card-reveal");
    runComponentDefault("line-reveal", "[data-line-reveal]");
    runComponentDefault("btn-hover", ".btn-hover");
    runComponentDefault("char-hover", ".char-hover__text");
    runComponentDefault("spotlight", ".spotlight");
    runComponentDefault("accordion", ".accordion");
    runComponentDefault("tabs", ".tabs");
    runComponentDefault("c-select", ".c-select");
    runComponentDefault("filter-bar", ".filter-bar");
    runComponentDefault("search-bar", ".search-bar");
    runComponentDefault("cursor-follower", "[data-cursor-text]");
    runComponentDefault("video", ".video");
    runComponentDefault("studio-info-time", ".studio-info--time");
    runComponentDefault("studio-info-weather", ".studio-info--weather");
    runComponentDefault("search-panel", "[data-panel='search']");
    runComponentDefault("mini-card", ".mini-card");
    runComponentDefault("mini-gallery", ".mini-gallery");
    runComponentDefault("region-picker", ".region-picker");
    runComponentDefault("buzzword", ".buzzword__word");
}

function initModuleScripts() {
    runModuleDefault("slider", ".slider");
    runModuleDefault("half", ".half");
    runModuleDefault("simple-intro", ".simple-intro");
    runModuleDefault("service-nav", ".service-nav");
    runModuleDefault("content-slider", ".content-slider");
    runModuleDefault("clients", ".clients__grid");
    runModuleDefault("wordplay", ".wordplay__row");
    runModuleDefault("quotes", ".quotes__slider");
    runModuleDefault("quotes-cta", ".quotes-cta");
    runModuleDefault("projects-map", ".listing__map");
    runModuleDefault("studio-map", ".studio-map__map");
    runModuleDefault("project-slider", ".project-slider__item");
    runModuleDefault("momentum-slider", ".momentum-slider__panel");
    runModuleDefault("insights-slider", ".insights-slider__item");
    runModuleDefault("projects-listing", ".listing__wrapper, .c-switch");
    runModuleDefault("tabbed-forms", ".tabbed-forms");
    runModuleDefault("search-results", ".search-results");
}

function safeInit() {
    requestAnimationFrame(() => setTimeout(init, 1));
}

if (!(document.readyState === "loading")) safeInit();
else document.addEventListener("DOMContentLoaded", safeInit);
